@if (isHorizontal()) {
  <div class="scrollbar-hidden mx-auto w-full overflow-x-auto">
    <div class="flex px-10 pb-5" [style.min-width.rem]="6.5 * steps().length">
      @for (
        step of steps();
        track step;
        let first = $first;
        let last = $last;
        let index = $index
      ) {
        <div class="flex items-center" [class.w-full]="!first">
          <!-- step line -->
          @if (!first) {
            <div
              class="h-px w-full grow"
              [class.bg-french-blue-500]="
                isActiveStep(step) || isCompletedStep(step)
              "
              [class.bg-slate-200]="
                !isActiveStep(step) && !isCompletedStep(step)
              "
            ></div>
          }
          <!-- step number -->
          <div
            #stepElement
            class="relative grid h-6 w-6 shrink-0 grow-0 place-items-center rounded-full"
            [class.bg-french-blue-500]="
              isActiveStep(step) || isCompletedStep(step)
            "
            [class.bg-slate-200]="!isActiveStep(step) && !isCompletedStep(step)"
            (click)="activateStep(step)"
          >
            <span
              class="select-none text-xs"
              [class.text-white]="isActiveStep(step) || isCompletedStep(step)"
              [class.text-slate-500]="
                !isActiveStep(step) && !isCompletedStep(step)
              "
            >
              @if (!isCompletedStep(step) || isActiveStep(step)) {
                {{ index + 1 }}
              }
              @if (isCompletedStep(step) && !isActiveStep(step)) {
                <svg-icon
                  svgClass="w-3! h-3!"
                  src="/assets/icons/general/check.svg"
                />
              }
            </span>
            <!-- step label -->
            <span
              class="absolute -bottom-5 left-1/2 w-24 -translate-x-1/2 select-none truncate text-center text-sm font-semibold"
              [class.text-french-blue-500]="
                isActiveStep(step) || isCompletedStep(step)
              "
              [class.text-slate-500]="
                !isActiveStep(step) && !isCompletedStep(step)
              "
              (click)="activateStep(step)"
            >
              {{ step.label }}
            </span>
          </div>
        </div>
      }
    </div>
  </div>
}

@if (isVertical()) {
  <div class="scrollbar-hidden mx-auto h-full w-full overflow-y-auto p-1">
    <div class="flex flex-col gap-5">
      @for (step of steps(); track step; let index = $index) {
        <div class="flex items-center gap-3" (click)="activateStep(step)">
          <!-- step number -->
          <div
            class="grid h-6 w-6 shrink-0 grow-0 place-items-center rounded-full"
            [class.bg-french-blue-500]="
              isActiveStep(step) || isCompletedStep(step)
            "
            [class.bg-slate-200]="!isActiveStep(step) && !isCompletedStep(step)"
          >
            <span
              class="select-none text-xs"
              [class.text-white]="isActiveStep(step) || isCompletedStep(step)"
              [class.text-slate-500]="
                !isActiveStep(step) && !isCompletedStep(step)
              "
            >
              @if (!isCompletedStep(step) || isActiveStep(step)) {
                {{ index + 1 }}
              }
              @if (isCompletedStep(step) && !isActiveStep(step)) {
                <svg-icon
                  svgClass="w-3! h-3!"
                  src="/assets/icons/general/check.svg"
                />
              }
            </span>
          </div>
          <!-- step label -->
          <span
            class="select-none text-sm font-semibold"
            [class.text-french-blue-500]="
              isActiveStep(step) || isCompletedStep(step)
            "
            [class.text-slate-500]="
              !isActiveStep(step) && !isCompletedStep(step)
            "
          >
            {{ step.label }}
          </span>
        </div>
      }
    </div>
  </div>
}
